import { T } from '@tolgee/react';
import IAntdMenuItem from '../interfaces/IAntdMenuItem';
import IUserMenu from '../interfaces/IUserMenu';
import getMenuIcon from './getMenuIcon';
import hasMenuPermission from './hasMenuPermission';

// Recursively filter menu items and their children based on permissions for N-level navigation
const getMenus = (
  menus: IUserMenu[] = [],
  rolePermissions: string[] = [],
): IAntdMenuItem[] => {
  if (!menus || !menus.length) return [];

  const filteredMenus = menus.filter(menu =>
    hasMenuPermission(menu, rolePermissions),
  );

  return filteredMenus.map((menu: IUserMenu) => {
    const rawChildren =
      menu.children && menu.children.length > 0
        ? getMenus(menu.children, rolePermissions)
        : [];

    const children = rawChildren.length > 0 ? rawChildren : undefined;
    const cleanLabel = (menu.label && menu.label.trim().length > 0)
      ? menu.label.trim()
      : (menu.name ? menu.name.split('>').pop()?.trim() : '') || menu.name;

    return {
      key: menu.id ? menu.id.toString() : (menu.path || menu.name),
      label: <T keyName={menu.name} defaultValue={cleanLabel} />,
      icon: getMenuIcon(menu.icon, cleanLabel || menu.name),
      children,
    } as IAntdMenuItem;
  });
};

export default getMenus;
